import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clientActions } from 'store';
import { CustomDelete, SimpleTooltip } from 'components';
import { formatAddress, Images, PermissionList, RolePermission, useModal } from 'utils';
import { serviceSingleStyles } from './styles';
import { SchedulingAddressModal, schedulingAddressOptions, schedulingOptionKey } from '../../clientModals';

const CLEAR_ACTION_TYPE = 'CLEAR_CLIENT_SCHEDULING_ADDRESS';

/**
 * "Scheduling address" block of the client Address card — the address new appts pre-select.
 * Data: state.client.clientSchedulingAddress ({ selected, options }), loaded by ClientAddress.
 */
export const ClientSchedulingAddress = () => {
    const classes = serviceSingleStyles();
    const dispatch = useDispatch();
    const { open } = useModal();
    const clientById = useSelector((state) => state.client.clientItemInfo);
    const schedulingAddress = useSelector((state) => state.client.clientSchedulingAddress);
    const canEdit = RolePermission([PermissionList.CLIENT_CREATE?.code]);

    const selected = schedulingAddress?.selected;
    const option =
        selected && schedulingAddress?.options?.find((item) => item.type === selected.type && item.id === selected.refId);
    const title = selected?.name || option?.label;
    const address = formatAddress(option?.address).full || option?.address?.formattedAddress;

    const openModal = () => open(<SchedulingAddressModal />);

    const clearSchedulingAddress = () => {
        open(
            <CustomDelete
                text="Are you sure you want to remove the scheduling address? New appointments will pre-select the client's default address."
                info="Remove Scheduling Address"
                handleDel={() => dispatch(clientActions.clearSchedulingAddress(clientById?.id))}
                actionType={CLEAR_ACTION_TYPE}
                body={
                    <div className="deleting-client-info-box" style={{ alignItems: 'flex-start' }}>
                        <img style={{ marginTop: '3px' }} src={Images.removeAddress} alt="icon" />
                        <p style={{ fontWeight: 400 }}>{address}</p>
                    </div>
                }
            />
        );
    };

    if (!schedulingAddress || (!option && !schedulingAddressOptions(schedulingAddress.options).length)) {
        return null;
    }

    return (
        <div className={classes.schedulingBox} key={option ? schedulingOptionKey(option.type, option.id) : 'empty'}>
            {option ? (
                <>
                    <div>
                        <p className={classes.schedulingCaption}>Scheduling address</p>
                        {title && <p className={classes.boldText}>{title}</p>}
                        <p className={classes.regularText}>{address}</p>
                    </div>
                    {canEdit && (
                        <div className='flex-align-center'>
                            <button onClick={clearSchedulingAddress}>
                                <img src={Images.remove} alt="icon" />
                            </button>
                            <button id="scheduling-address-edit-btn" onClick={openModal}>
                                <img src={Images.edit} alt="icon" />
                            </button>
                        </div>
                    )}
                </>
            ) : (
                <>
                    <div>
                        <p className={classes.schedulingCaption}>Scheduling address</p>
                        <p className={classes.regularText}>Not selected</p>
                    </div>
                    {canEdit && (
                        <SimpleTooltip title={<p>Set scheduling address</p>} placement="top-end">
                            <button id="scheduling-address-add-btn" onClick={openModal}>
                                <img src={Images.addCircleBlue} alt="icon" />
                            </button>
                        </SimpleTooltip>
                    )}
                </>
            )}
        </div>
    );
};
